import { useCurrentSubscription } from 'features/subscription'
import { useWorkspaceEnvironments } from 'hooks/api/environment'
import { useMemo } from 'react'

import { GLOBAL_ENVIRONMENT_LABEL, GLOBAL_ENVIRONMENT_VALUE } from '../../workspaceEnvironments'

/**
 * Hook to get environment name by id.
 */
export function useGetEnvironmentName(environmentId: string): string | undefined | null {
  const { currentSubscriptionId } = useCurrentSubscription()
  // If environmentId is not provided, we don't need to fetch environments
  // so we pass null to the hook to avoid unnecessary API calls.
  const shouldFetchWorkspaceEnvironments = Boolean(environmentId) && environmentId !== GLOBAL_ENVIRONMENT_VALUE
  const { data: workspaceEnvironments, isLoading: isLoadingWorkspaceEnvironments } = useWorkspaceEnvironments(
    shouldFetchWorkspaceEnvironments ? currentSubscriptionId : null
  )

  const name = useMemo(() => {
    if (!environmentId) {
      return undefined
    }

    if (environmentId === GLOBAL_ENVIRONMENT_VALUE) {
      return GLOBAL_ENVIRONMENT_LABEL
    }

    return workspaceEnvironments?.find((env) => env.id === environmentId)?.name
  }, [workspaceEnvironments, environmentId])

  return isLoadingWorkspaceEnvironments ? null : name
}
